import React, { type ReactElement } from 'react';

const AddUsersIcon = (): ReactElement => (
  <svg width="140" height="140" viewBox="0 0 140 140">
    <defs>
      <circle id="x1ryj3psza" cx="24" cy="24" r="24" />
      <circle id="qx3sgzeufc" cx="40.5" cy="40.5" r="40.5" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g transform="translate(-354 -157) translate(63 157) translate(291) translate(16 26)">
                <mask id="ub4mvzu6jb" fill="#fff">
                  <use href="#x1ryj3psza" />
                </mask>
                <use fill="#D7DBEC" href="#x1ryj3psza" />
                <circle
                  cx="24"
                  cy="18"
                  r="8"
                  fill="#131523"
                  mask="url(#ub4mvzu6jb)"
                />
                <path
                  fill="#131523"
                  d="M24 30c7.724 0 14.328 4.887 17 11.794C36.693 46.24 30.669 49 24 49c-6.668 0-12.693-2.762-16.999-7.206C9.674 34.886 16.278 30 24.001 30z"
                  mask="url(#ub4mvzu6jb)"
                />
              </g>
              <g transform="translate(-354 -157) translate(63 157) translate(291) translate(16 26) translate(27 7)">
                <mask id="kf42bwflfd" fill="#fff">
                  <use href="#qx3sgzeufc" />
                </mask>
                <use fill="#2765CF" href="#qx3sgzeufc" />
                <use fill="#2765CF" />
                <circle
                  cx="40.5"
                  cy="30.5"
                  r="13.5"
                  fill="#B6CBFF"
                  mask="url(#kf42bwflfd)"
                />
                <path
                  fill="#B6CBFF"
                  d="M40 50c13.691 0 25.345 9.11 29.706 21.842C62.311 79.363 52.178 84 41 84c-11.918 0-22.648-5.271-30.14-13.687C15.605 58.386 26.865 50 40 50z"
                  mask="url(#kf42bwflfd)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default AddUsersIcon;
